module.exports = __webpack_public_path__ + "static/media/21ECLAC41.2d06acae.jpg";